import React from 'react';
import Widget from "../../../components/prefabricated/Widget";

const UserManualHeaderWidget = ({title = null,
                                icon = null,
                                subtitle=null, }) => {
    return(
        <Widget styleName={`px-2 bg-light text-muted`} >
            <div className="d-flex flex-row justify-content-center mt-1 mb-4">
                            <span
                                className={`size-70 d-flex flex-row justify-content-center align-items-center rounded-circle`}>
                                        {icon && icon}
                            </span>
            </div>
            <div className="text-center">
                <h2 className={`jr-fs-xxxl jr-font-weight-bold mb-2`}>
                    {title && title}
                </h2>
                <span className={`fadeIn animation-duration-10`}>
                    {subtitle && subtitle}
                </span>
            </div>
        </Widget>
    )
}

export default UserManualHeaderWidget;